<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useDecisionSupportWizardStore } from '../../stores/decision-support-wizard.store';
import type { DecisionSupportWizardParcelData } from '../../models/decision-support-wizard.model';
import { computed, type PropType } from 'vue';

const props = defineProps({
  parcel: {
    type: Object as PropType<DecisionSupportWizardParcelData>,
    required: true
  }
});

const decisionSupportWizardStore = useDecisionSupportWizardStore();
const { decisionSupportData } = storeToRefs(decisionSupportWizardStore);

const ownMetadata = computed(() => decisionSupportData.value.metadata.parcels.find((p) => p.id === props.parcel.id));
</script>

<template>
  <div v-if="ownMetadata">
    <div>
      <span class="text-subtitle-2"> {{ $t('decisionSupport.wizard.label.upkeepCost') }}:&nbsp;</span>
      <span class="text-grey-darken-2 text-subtitle-2"> {{ ownMetadata.upkeepCost }} Ft/ha </span>
    </div>
    <div>
      <span class="text-subtitle-2"> {{ $t('decisionSupport.wizard.label.cropPrice') }}:&nbsp;</span>
      <span class="text-grey-darken-2 text-subtitle-2"> {{ ownMetadata.cropPrice }} Ft/t </span>
    </div>
    <div>
      <span class="text-subtitle-2"> {{ $t('decisionSupport.wizard.label.sourceName') }}:&nbsp;</span>
      <span class="text-grey-darken-2 text-subtitle-2">
        {{ ownMetadata.layerGroupName }}
      </span>
    </div>
  </div>
</template>
